import { useContext } from "react";
import RequestsTable from "../../../components/RequestsTable/RequestsTable";
import { UserContext } from "../../../context/UserContext";
import useRequestsByProvider from "../../../hooks/useRequestsByProvider";

const ActiveRequests = () => {
  const {
    user: { medical_provider_id: providerId },
  } = useContext(UserContext);

  // Fetch provider-specific requests
  const { requests, reloadRequests } = useRequestsByProvider(
    providerId,
    "Active"
  );

  return (
    <RequestsTable
      title={"Active Requests"}
      requests={requests}
      reloadRequests={reloadRequests}
      showActions={true}
    />
  );
};

export default ActiveRequests;
